import { type FetchFanShopProductTypesParams } from '@capsicum/common';

import { useProductTypesQuery } from '../data-access/queries/useProductTypesQuery';

export const useProductTypes = (params?: FetchFanShopProductTypesParams) => {
	const { data, isLoading } = useProductTypesQuery(params);

	return {
		isLoading,
		productTypes: data || []
	};
};
